import EventBase from './EventBase'
import EventID from './EventID'
import Str from '../Str'

import EventTextDifExBase from './EventTextDifExBase'

/**
 * 1010   剧情分歧EX
 */
export default class EventTextDifEx extends EventTextDifExBase {
  public TIME_END = 'ORGTIMEOVER|结束项'
  ShowConditionList: string[] = []

  /**
   * @param 传进来的剧情分歧项 
   */
  public constructor(param: string[]) {
    super()
    if (param) {
      const newtemp = param.filter((t) => t !== this.TIME_END)
      this.Parameter = new Array(param.length * 2 + 9)
      for (var i = 0; i < this.Parameter.length; i++){
        this.Parameter[i] = ""
      }
      for (let i = 0; i < this.InitialParam.length; i++) {
        if (i == 0){
          this.Parameter[i] = 'ORGTEXT|' + this.InitialParam[i]
        } else {
          this.Parameter[i] = this.InitialParam[i]
        }
      }
      this.ChoiceText = param
    } else {
      this.ShowConditionList = new Array<string>()
    }
  }

  // public ChoiceText:string[]
  // #region 数据绑定相关的都在这里
  /**
   * 选项内容
   */
  get ChoiceText() {
    const list = new Array<string>()
    for (let i = 9; i < this.Parameter!.length; i += 2) {
      list.push(this.Parameter![i])
    }
    return list
  }
  
  set ChoiceText(value:string[]) {
    let j = 0
    for (let i = 9; i < this.Parameter!.length; i += 2) {
      this.Parameter![i] = value[j]
      j++
    }
  }

  /**
   * 选项出现条件
   */
  get ChoiceShowCondition() {
    return this.ShowConditionList
  }
  set ChoiceShowCondition(value) {
    if (!this.ShowConditionList) {
      this.ShowConditionList = new Array<string>()
    } else {
      this.ShowConditionList = []
    }
    let j = 0
    for (let i = 10; i < this.Parameter!.length; i += 2) {
      this.Parameter![i] = value[j]
      this.ShowConditionList.push(value[j])
      j++
    }

    // TODO:
    // if(this.PropertyChanged != null)
    // {
    // 	this.PropertyChanged.Invoke(this, new PropertyChangedEventArgs("ChoiceShowCondition"));
    // }
  }

  public endItem: string = ''
  /**
   * 结束项
   */
  get EndItem() {
    return this.endItem
  }
  set EndItem(value) {
    const tempStr = [...this.Parameter!]
    this.Parameter = new Array(this.Parameter!.length + 1)
    for (let i = 0; i < tempStr.length; i++) {
      this.Parameter[i] = tempStr[i]
    }
    this.Parameter[this.Parameter.length - 1] = value
    this.endItem = value
    this.Parameter[this.Parameter.length - 1] = value
  }

  public GetParameter() {
    return this.Parameter
  }
  public SetShowConditionInit() {
    this.ShowConditionList = []
    for (let i = 10; i < this.Parameter!.length; i += 2) {
      this.ShowConditionList.push(this.Parameter![i])
    }
  }
}
